import React, { useState, useEffect } from 'react';
import Blog from '../Blog/Blog';
import './Blogs.css'

const Blogs = () => {
    // fetching and setting blogs to state
    const [blogs, setBlogs] = useState([]);
    useEffect(() => {
        fetch('blogs.json')
            .then(res => res.json())
            .then(data => setBlogs(data))
    }, [])
    return (
        <section>
            <div className='blogs'>
                {
                    blogs.map(blog => <Blog key={blog.id} blog={blog}></Blog>)
                }
            </div>
        </section>
    );
};

export default Blogs;